import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-marksstu',
  templateUrl: './marksstu.component.html',
  styleUrls: ['./marksstu.component.scss'],
  providers:[MasterService,ClassroomService]
})
export class MarksstuComponent implements OnInit {

  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
    sections:any=[];
    classes:any=[];
    arrstudent:any=[];
    fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0'};
    arrrepdata:any=[];
    arrper:any=[];
    arrashead:any=[];
    arrcourse:any=[];
    arrastype:any=[];
    arrastype1:any=[];
    oprtype:any='';
    tabledata: any = {};
    rcremarks='';
    fileToUpload: File = null;
    arrcat:any=[{name:'Board'},{name:'Competitive'}];

fData: FormData = new FormData;
    constructor(private http: HttpClient,private aservice:ClassroomService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
  
    ngOnInit(): void {
      this.fmodel.ascat='Board';
      this.masasshead();
      this.masasstype();
      this.mascourse();
     

      //this.subjects();
      this.fmodel.attdt=this.mservice.getdatetoday();
      this.fmodel.frtime=this.mservice.getcurenttime();
      this.fmodel.totime=this.mservice.getcurenttime();
      
     
    }
  
    checknumber(ele) {
      if (ele.score < 0 || ele.score==null  )
      {

        ele.score = 0.00;
      }
      else if (ele.score > ele.maxsc) {
        alert('Marks should be less than or equal to maxscore');
        ele.score = ele.accscore1;
  
        console.log("accscore1", ele.accscore1 + " & " + ele.accscore);
      }
      // else {
      //   ele.accscore = parseFloat(ele.accscore).toFixed(0);
      // }
    }
    masclass() {
      this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.fmodel.clid=resultArray[0].clid;
              this.massection();
            //  this.masperiod();
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

    masperiod() {
      this.mservice.masperiod(this.fmodel.clid)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrper = resultArray;
              this.fmodel.prid=resultArray[0].id;
             
             
          },
          error => console.log("Error :: " + error)
          )
    }
    massection() {
      this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.sections = resultArray;
              this.fmodel.secid=resultArray[0].scid;
             // this.masasshead();
             this.getstudentsdata();
          },
          error => console.log("Error :: " + error)
          )
    }

    masasshead() {
      this.mservice.sel_sp_masasshead()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrastype1 = resultArray;
            //  this.fmodel.assid=resultArray[0].asid;
             // this.masasstype();
             this.onchangeasscat();
          },
          error => console.log("Error :: " + error)
          )
    }
    masasstype() {
      this.mservice.sel_sp_masasstype()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrastype = resultArray;
              this.fmodel.asstypeId=resultArray[0].astpid;
          },
          error => console.log("Error :: " + error)
          )
    }
 
onchangeasscat()
{
  this.arrashead=this.arrastype1.filter(item => item.ascat===this.fmodel.ascat);
  this.fmodel.assid=this.arrashead[0].asid;
  this.SelectReportDetails();
}
      onclasschange()
      {
        this.massection();
this.getstudentsdata();
      }
  
      SelectReportDetails() {
        var clid = this.fmodel.clid;
        var secid = this.fmodel.secid;
        var assid = this.fmodel.assid;
        var asstypeid = this.fmodel.asstypeId;
        var subid = this.fmodel.stuid;
        //var stuid = this.studata.stuid;
        //var name = this.studata.name;
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
    var oprtype="";
        if(this.fmodel.ascat=="Board")
        {
oprtype="selbystuid";
        }
        else{

          oprtype="comselbystuid";
        }
    
        var modeldata = { assid: assid, clid: clid, asstypeId: asstypeid, stuid: subid, secid: secid,clcd:clcd,aycd:aycd,oprtype:oprtype };
        //console.log('model',assid);   
        this.fmodel.dbnm = '';
       // this.model = f.value;
        console.log('model', modeldata);
        this.aservice.select_sp_marksdetail(modeldata)
          .subscribe(resultArray => {
            console.log('ret-select', resultArray);
            this.arrrepdata = resultArray.by_sp_marksdetail;
            this.rcremarks = resultArray.rcremarks;
            //alert (resultArray.message);
    
          }, error =>
            alert('error in connection')
          );
    
       
      }


      Savercremarks(obj) {
        var objpost={asid:obj.assid,stuid:obj.stuid,rcremarks:this.rcremarks};
        this.aservice.Savercremarks(objpost)
          .subscribe(result => {
            console.log('ret-loop', result);
            alert(result.message);
            //this.Getsel_sp_masassmodel();
          }, error =>
            alert('error in connection')
          );
      }
  
      saveMarksDetails() {
        console.log('testdata', this.arrrepdata);
        this.tabledata.loopdata = this.arrrepdata;
        this.tabledata.dbnm = '';
    
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        this.tabledata.clcd=clcd;
        this.tabledata.aycd=aycd;
        var oprtype="";
        // this.tabledata.oprtag='update';
        if(this.fmodel.ascat=="Board")
        {
oprtype="update";
        }
        else{

          oprtype="comupdate";
        }
        this.tabledata.oprtype=oprtype;
        console.log('marks-data', this.tabledata);
        this.aservice.loop_reportcard(this.tabledata)
          .subscribe(result => {
            console.log('ret-loop', result);
            alert(result.message);
            //this.Getsel_sp_masassmodel();
          }, error =>
            alert('error in connection')
          );
      }
      mascourse() {
        this.mservice.mascourse()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrcourse = resultArray;
                this.fmodel.crid=resultArray[0].crid;
                this.masclass();
                //this.fmodel1.crid=resultArray[0].crid;
            },
            error => console.log("Error :: " + error)
            )
      }
      by_sp_student() {
        debugger
       var dbnm = '';
         var clid = this.fmodel.clid;
         var secid = this.fmodel.secid;
         var brid = '0';
         this.aservice.by_sp_student(clid, secid,brid)
          .subscribe(
          resultArray => {
            console.log('std-result', resultArray);
            this.arrstudent = resultArray;        
          },
          error => console.log("Error :: " + error)
          );
      }

      getstudentsdata() {
        this.aservice.getstudents_clwise(this.fmodel.clid,this.fmodel.secid,this.fmodel.crid)
            .subscribe(
            resultArray => {
                console.log('bloodgp', resultArray);
                this.arrstudent = resultArray;
               this.fmodel.stuid= resultArray[0].stuid;
                this.SelectReportDetails();
            },
            error => console.log("Error :: " + error)
            )
      }


      upload(files: FileList) {
        debugger;
        this.fileToUpload = files.item(0);
      
       
      }
      
      
     
      fileupload()
      {
      debugger
      
      console.log('file data',JSON.stringify(this.fileToUpload));
      
      this.aservice.uploadphoto(this.fileToUpload,1)
      .subscribe(fresult => {
         // console.log('ret',JSON.stringify(fresult));
          alert (fresult.message);
          if(fresult.status=='Success')
      {
      // let localmodref=this.modalRef;
      // localmodref.close();
      //this.Refreshsummary();
      this.fileToUpload=null;
      // this.dcid=0;
      // this.disuploadbtn=true;
      // this.photo=fresult.updfilepath;
      
      }
          
      }, error => 
      alert('error in connection')
      
      );
      
      
      
      }

      openinfo(content)
 {
  
 
   this.modalOptions = {
     backdrop:'static',
     backdropClass:'customBackdrop',
     size:'lg'
    }
   this.modalRef=this.modalService.open(content,this.modalOptions);
   
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         //this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
         //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
 }
 
        
  }
